import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { ChevronRight, Search } from "baseui/icon";
import { Input } from "baseui/input";
import { ListItem, ListItemLabel } from "baseui/list";
import { useMemo, useState } from "react";
import { AiOutlineAppstore } from "react-icons/ai";
import { HierarchyBreadcrumbs } from ".";
import { IAutomationObject } from "../../automationObjects";
import { GetAppIcon } from "../../automationObjects/automationObjectsSelector";
import { ParagraphSmall, ParagraphXSmall } from "baseui/typography";
import { SelectableListItem } from "../../components/SelectableListItem";


export interface OneLayerObjectsSelectViewProps {
    objects: IAutomationObject[] | undefined,
    parentObjectId: string,
    parentResouceGroupId: string,
    selectedItem: IAutomationObject | undefined,
    onShowChildren: (args?: onShowChildrenArgs) => void,
    onItemSelected: (item: IAutomationObject) => void,

}
export type onShowChildrenArgs = {
    id: string,
    resourceGroupId: string
}


const OneLayerObjectsSelectView = ({ objects, parentObjectId, parentResouceGroupId, selectedItem, onShowChildren, onItemSelected }: OneLayerObjectsSelectViewProps) => {
    const [css] = useStyletron();

    const [search, setSearch] = useState("");
    const onSearchChanged = (e: any) => setSearch(e.target.value)


    const filterdItems = useMemo(() => {
        // filter alarms
        return objects?.slice()?.filter((a) => !a.description || a.description?.toLowerCase().includes(search.toLowerCase()))
    }, [objects, search])

    return (
        <Block gridGap='20px' display='flex' flexDirection='column'>
            <HierarchyBreadcrumbs resourceGroupId={parentResouceGroupId} objectId={parentObjectId} onNavigate={onShowChildren}></HierarchyBreadcrumbs>
            <Input
                endEnhancer={<Search size="18px" />}
                placeholder="Search..."
                onChange={onSearchChanged}
            />
            <div className={css({
                overflowY: "auto",

            })}>
                <ul
                    className={css({
                        paddingLeft: 0,
                        paddingRight: 0,
                        margin: 0,
                        width: "auto",
                    })}
                >
                    {filterdItems?.map((item: IAutomationObject, index: number) =>
                    (<Item key={item.id} onItemSelected={onItemSelected} item={item} selectedItem={selectedItem} onShowChildren={onShowChildren} />
                    ))}
                </ul>
            </div>
        </Block>
    )
}

export default OneLayerObjectsSelectView


function Item({ onItemSelected, item, selectedItem, onShowChildren }) {
    const [css, theme] = useStyletron();

    const Icon = GetAppIcon(item.schema) || AiOutlineAppstore;
    return (
        <SelectableListItem
            onSelect={onItemSelected}
            isSelected={selectedItem === item}
            item={item}
            key={item.id}
            shape="ROUND"
            artwork={() => <Icon color={theme.colors.primary600} size="1.5em" width="1.5em" {...item}></Icon>}
            endEnhancer={() =>
            (<>
                <Button onClick={e => { e.preventDefault(); onShowChildren({ id: item.id, resourceGroupId: item.resourceGroupId }); }}
                    size="compact" kind="tertiary" shape="pill">
                    <ChevronRight size='scale1000' />
                </Button>
            </>)
            }>
            <ListItemLabel description={item.name}>
                {item.description}
            </ListItemLabel>
        </SelectableListItem>
    );
}
